@use "../../../styles/variables.scss" as *;
@use "design-system/src/styles/tokens/mixins.scss" as ds-mixins;

.footer {
  display: flex;
  margin-top: 32px;
  flex-grow: 0;

  .buttonContainer {
    margin: 0 auto 32px;
    display: flex;
    width: 100%;
    justify-content: center;
    max-width: 28rem;
    flex-direction: column;
    gap: 8px;

    .footerButton {
      padding: 24px 0;
      flex-grow: 1;
      font-family: $font-family-brand;
      font-size: 20px;
      line-height: 24px;
      background-color: $almost-black;
      border: none;
      border-radius: 9999px;
      font-weight: 400;
      display: flex;
      justify-content: center;
      gap: 8px;
      align-items: center;
      flex-basis: 100%;
      flex-shrink: 1;

      &div {
        border: none;
        border-radius: 38px;
        margin-bottom: 24px;
      }

      &.footerButtonPrimary {
        color: $light-volt;
      }

      &.footerButtonSecondary {
        color: $white;
      }

      &:disabled {
        background-color: $light-gray;
        color: $gray;
      }

      &:focus {
        @include ds-mixins.focus-effect;
      }

      .footerSpinner:after {
        border-color: $light-volt $light-volt $light-volt transparent;
      }

      span {
        color: $light-volt;
        font-size: 20px;
        line-height: 24px;
        font-family: $font-family-brand;
      }
    }

    @media (min-width: $desktop-breakpoint) {
      flex-direction: row;
      gap: 1px;

      .footerButton {
        border-radius: 0;

        &:first-child {
          border-top-left-radius: 9999px;
          border-bottom-left-radius: 9999px;
          border-left: none;
        }

        &:last-child {
          border-top-right-radius: 9999px;
          border-bottom-right-radius: 9999px;
          border-right: none;
        }
      }
    }

    button.footerButton:hover {
      color: $almost-black;
      background-color: $light-volt;
      cursor: pointer;

      &:disabled {
        background-color: $light-gray;
        color: $gray;
        cursor: not-allowed;
      }
    }
  }

  .footerNote {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 0 16px 1.5rem;

    p {
      font-size: 12px;
      line-height: 16px;
    }
  }
}
